import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { LOGO_URL } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full bg-[#121212] border border-white/10 focus:border-[#d4af37] outline-none px-4 py-3 text-sm text-white placeholder:text-white/35 transition-colors duration-300";

const formatErr = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return "Login failed. Please try again.";
};

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("zuri_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-[#121212] border hairline p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Zuri Sana" className="h-12 w-12 rounded-full object-cover ring-1 ring-[#d4af37]/50" />
          <div>
            <p className="font-serif-display text-xl text-white">Staff Portal</p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#d4af37]">Zuri Sana Hotel</p>
          </div>
        </div>
        <div className="space-y-4">
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Admin email" className={inputCls} data-testid="admin-email-input" />
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputCls} data-testid="admin-password-input" />
        </div>
        <button type="submit" disabled={loading} className="btn-gold w-full mt-6 px-8 py-4 text-[12px] tracking-[0.2em] uppercase font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-btn">
          <Lock size={14} /> {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
